import React, {useEffect, useState} from 'react';
import {Navigate} from 'react-router-dom';
import useAuth from '@mgp-fe/shared/modules/auth/hooks/useAuth.ts';
import routes from '@mgp-fe/customer/router/routes.ts';
import Logo from '@mgp-fe/shared/assets/logo/text-logo.svg';

export default function SignInWithLink({token}: SignInWithLinkProps) {
	const {loginWithToken, isUserLoading} = useAuth();
	const [isTokenStored, setIsTokenStored] = useState(false);

	useEffect(() => {
		loginWithToken(token).finally(() => setIsTokenStored(true));
	}, []);

	if (!isTokenStored || isUserLoading) return <div className='w-screen h-screen flex flex-col items-center justify-center animate-pulse gap-8'>
		<Logo className='fill-primary w-52 md:w-72 lg:w-80'/>
		<h1 className='h3 md:h2 lg:h3 uppercase text-secondary text-4xl font-semibold'>Signing in...</h1>
	</div>;

	// OnboardingGuard sends customers with unfinished onboarding back to onboarding
	return <Navigate to={routes.index} replace/>;
}

interface SignInWithLinkProps {
	token: string;
}
